/**
 * Any Student API calls with React Query.
 */
import { useMemo } from "react";
import moment from "moment";
import { GetMentoredStudentsListCancelToken, GetMentoredStudentsDropdownCancelToken } from "../../services/DashBoardServices";
import { QUERY_CACHE_PROFILES, QUERY_KEYS } from "../queryConsts";
import { useBaseReactQuery } from "./useBaseReactQuery";

const EMPTY_STUDENTS_DROPDOWN = Object.freeze({
    course: [],
    course_type: [],
    student_activity_status: [],
    activity: [],
    lecturer: [],
    programme: [],
    mStatus: [],
    status: [],
});

const EMPTY_STUDENTS_LIST = Object.freeze({
   studentsList: [],
    totalRows: 0
});

export const StudentsTabNames = {
    InProgress: "in_progress",
    PendingSignOff: "pending_sign_off",
    NotesPendingResponse: "notes_pending_response",
    NotYetStarted: "not_started",
    PastRecommendedStart: "past_recommended_start",
    PastComittedEnd: "past_comitted_end"
};

/**
 * Students Dropdown - PERSISTED
 * @param {StudentsTabNames} Tab Online Classes Tab name.
 * @returns {DefinedUseQueryResult} React Query result
 */
export function useStudentsDropdown(filters) {
    const query = useBaseReactQuery(
        [QUERY_KEYS.students.root, QUERY_KEYS.students.studentsDropdown, filters],
        async () => {
            const { data } = await GetMentoredStudentsDropdownCancelToken(filters);
            return {
                ...data,
                course: data.Course,
                programme: data.Programme,
                status: data.studentStatus,
                mStatus: data.MentoringStatus,
                lecturer: data.lecturer,
                course_type: data.courseType,
            };
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.LOOKUP
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_STUDENTS_DROPDOWN
    };
}

/**
 * React Query hook for Students lists.
 * The requestData should already be in the format expected by the API.
 *
 * @param {object} requestData Request body passed directly to the API.
 * @returns {DefinedUseQueryResult}
 */
export function useStudentsList(requestData) {
    const query = useBaseReactQuery(
        [
            QUERY_KEYS.students.root,
            QUERY_KEYS.students.studentsList,
            requestData
        ],
        async () => {
            const { data } = await GetMentoredStudentsListCancelToken(requestData);
            return {
               studentsList: data?.result ?? [],
                totalRows: data?.Pagination?.total ?? 0
            };
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.TABLE
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_STUDENTS_LIST
    };
}


